import {
  IUpdateUserPermissionsRequest,
  permissionConfig,
  PermissionLevel,
  PermissionTypes,
  UserTypes,
} from "shared";

import { Modal } from "../../../../common/Atoms/Modal";
import { Paragraph } from "../../../../common/Atoms/Typography/Paragraph";
import { Select } from "../../../../common/Atoms/Select";
import { useUpdatePermissionsMutation } from "../../../services/api/permissionsApi/permissions";
import { useGetSelectedOrganisation } from "../../../hooks/useGetSelectedOrganisation";
import { LoadingOverlay } from "../../Molecules/LoadingOverlay";
import { settingPermissionOptions } from "../../../lib/helper";

interface PermissionModalProps {
  open: boolean;
  setOpen: () => void;
  userConnection: {
    firstName: string;
    lastName: string;
    email: string;
    connected: boolean;
    lastLogin?: Date;
    type: UserTypes;
    id: string;
    permissionSettings: PermissionLevel;
  };
}

export function PermissionModal({
  open,
  setOpen,
  userConnection,
}: PermissionModalProps) {
  const [updatePermissions, { isLoading: updatePermissionsLoading }] = useUpdatePermissionsMutation();
  const currentOrg = useGetSelectedOrganisation();

  function onPermissionChange(permission: PermissionTypes, level: PermissionLevel) {
    if (currentOrg && userConnection) {
      const update: IUpdateUserPermissionsRequest = {
        targetUserId: userConnection.id,
      };

      if (permission === PermissionTypes.SETTINGS) {
        update.permissionSettings = level;
      }

      updatePermissions({
        organisationId: currentOrg.id,
        update,
      });
    }
  }

  const content = (
    <LoadingOverlay
      loading={ updatePermissionsLoading }
      message={ `Updating permissions...` }
    >

      { /* Settings Permission Row */ }
      <div className={ `grid grid-cols-12 border-t pt-4` }>
        <div className={ `col-span-8` }>
          <Paragraph>
            { permissionConfig[PermissionTypes.SETTINGS].title }
          </Paragraph>
          <Paragraph
            variant={ `secondary` }
          >
            { permissionConfig[PermissionTypes.SETTINGS].description }
          </Paragraph>
        </div>

        <div className={ `col-span-4` }>
          <Select
            selected={ userConnection?.permissionSettings || `` }
            options={ settingPermissionOptions }
            onChange={ e => onPermissionChange(PermissionTypes.SETTINGS, e.value as PermissionLevel) }
          />
        </div>
      </div>
      <Paragraph
        className={ `mt-4` }
        variant={ `help` }>
        { `Looking for more detailed permissions? Please reach out to us with your request!` }
      </Paragraph>
    </LoadingOverlay>
  );

  return (
    <Modal
      open={ open }
      setOpen={ setOpen }
      title={ `Edit permission levels for ${userConnection?.email}` }
    >
      { content }
    </Modal>
  );
}
